
import React, { ReactNode } from "react";
import { User } from "@/models/user";
import { DashboardHeader } from "@/components/dashboard/DashboardHeader";
import { DashboardSidebar } from "@/components/dashboard/DashboardSidebar";
import { Toaster } from "@/components/ui/toaster";

interface DashboardLayoutProps {
  user: User;
  isLoading: boolean;
  children: ReactNode;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  walletData: {
    balance: number;
    agentsPurchased: number;
    lastPurchase: string;
  };
  loadingWallet: boolean;
}

export function DashboardLayout({
  user,
  isLoading,
  children,
  activeTab,
  setActiveTab,
  walletData,
  loadingWallet
}: DashboardLayoutProps) {
  const isCreator = user.profileType === 'creator';
  const title = isCreator ? "Creator Dashboard" : "User Dashboard";
  const subtitle = isCreator 
    ? "Manage your created AI agents and track performance" 
    : "Manage your AI agents and account";

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-4 md:py-12">
        <DashboardHeader 
          user={user}
          title={title}
          subtitle={subtitle}
        />

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6">
          {/* Sidebar */}
          <div className="md:col-span-1 sticky top-0 z-10 md:z-0 md:h-auto bg-background pb-2 md:pb-0">
            <DashboardSidebar 
              activeTab={activeTab} 
              setActiveTab={setActiveTab} 
              isCreator={isCreator}
              walletData={walletData}
              loadingWallet={loadingWallet}
            />
          </div>

          {/* Main Content */}
          <div className="md:col-span-3">
            {children}
          </div>
        </div>
      </div>
      <Toaster />
    </div>
  );
}
